import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { LangProvider } from './context/LangContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Ask from './pages/Ask';
import Patterns from './pages/Patterns';
import Practice from './pages/Practice';
import Book from './pages/Book';
import About from './pages/About';
import Login from './pages/Login';
import Register from './pages/Register';
import Pricing from './pages/Pricing';
import Account from './pages/Account';
import Billing from './pages/Billing';
import Admin from './pages/Admin';
import Guidance from './pages/Guidance';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <LangProvider>
          <AuthProvider>
            <Router>
              <div className="min-h-screen bg-dark flex flex-col">
                <Navbar />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/ask" element={<Ask />} />
                    <Route path="/patterns" element={<Patterns />} />
                    <Route path="/practice" element={<Practice />} />
                    <Route path="/book" element={<Book />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/billing" element={<Billing />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/guidance" element={<Guidance />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            </Router>
          </AuthProvider>
        </LangProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
